import VuetifyTextClass from '@/shared/constants/core/VuetifyTextClass'
import VuetifyColourClass from '@/shared/constants/core/VuetifyColourClass'

const { smallButton, mediumButton, largeButton } = VuetifyTextClass

const {
  black,
  grey200,
  grey500,
  grey700,
  blue200,
  blue400,
  blue500,
  text,
  transparent,
  primary,
  white,
} = VuetifyColourClass

const { btnSizeMap, iconBtnSizeMap, dotBtnSizeMap, fabSizeMap } = Object.freeze(
  {
    btnSizeMap: {
      sm: { width: 108, height: 36 },
      md: { width: 112, height: 40 },
      lg: { width: 116, height: 40 },
      xl: { width: 133, height: 48 },
      xxl: { width: 161, height: 59 },
    },
    iconBtnSizeMap: {
      sm: { width: 136, height: 36 },
      md: { width: 140, height: 40 },
      lg: { width: 144, height: 40 },
      xl: { width: 161, height: 48 },
      xxl: { width: 193, height: 59 },
    },
    dotBtnSizeMap: {
      sm: { width: 126, height: 36 },
      md: { width: 130, height: 40 },
      lg: { width: 134, height: 40 },
      xl: { width: 151, height: 48 },
      xxl: { width: 183, height: 59 },
    },

    fabSizeMap: {
      sm: { width: 36, height: 28 },
      md: { width: 40, height: 32 },
      lg: { width: 44, height: 36 },
      xl: { width: 48, height: 40 },
      xxl: { width: 56, height: 48 },
    },
  }
)

export default Object.freeze({
  // pixel values are passed to v-btn native min-width & min-height to allow for content expansion
  textSizeClassMap: {
    xl: mediumButton,
    xxl: largeButton,
    default: smallButton,
  },

  // pixel values passed to native v-icon size prop
  iconSizeMap: {
    dot: 8,
    xxl: 24,
    default: 20,
  },

  colorMap: {
    secondary: white,
    text: black,
    tertiary: transparent,
    tertiaryBlue: transparent,
    textBlue: blue400,
    default: primary,
  },

  hoverColorMap: {
    secondary: grey200,
    text: blue400,
    tertiary: blue200,
    tertiaryBlue: blue200,
    textBlue: blue500,
    default: blue500,
  },

  textColorMap: {
    secondary: text.black,
    text: text.black,
    tertiary: text.black,
    tertiaryBlue: text.blue,
    textBlue: text.blue,
    default: text.white,
  },

  iconColorMap: {
    secondary: grey500,
    text: grey700,
    tertiary: grey500,
    tertiaryBlue: blue400,
    textBlue: blue400,
    default: white,
  },

  iconHoverColorMap: {
    secondary: grey500,
    text: blue400,
    tertiary: blue400,
    tertiaryBlue: blue400,
    textBlue: blue500,
    default: white,
  },

  dimensionsMap: {
    fab: fabSizeMap,
    dot: dotBtnSizeMap,
    prependIcon: iconBtnSizeMap,
    appendIcon: iconBtnSizeMap,
    default: btnSizeMap,
  },
})
